import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000/api' : 'https://sms.optivcloud.com/api');

const api = axios.create({
  baseURL: API_BASE_URL,
  // Send the httpOnly auth cookie with every request. The JWT is no longer
  // stored in localStorage (which is readable by any XSS), so there is no
  // Authorization header to attach here — the browser sends the cookie.
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Read a readable cookie value (used for the CSRF double-submit token).
export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
};

// Attach the CSRF token (double-submit cookie pattern) on state-changing
// requests so the server can verify it against the csrfToken cookie.
const CSRF_SAFE_METHODS = ['get', 'head', 'options'];
api.interceptors.request.use((config) => {
  if (!CSRF_SAFE_METHODS.includes((config.method || 'get').toLowerCase())) {
    const csrf = getCookie('csrfToken');
    if (csrf) config.headers['X-CSRF-Token'] = csrf;
  }
  return config;
});

// Response interceptor to handle expired/invalid sessions.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      // Avoid redirect loops when already on an auth page.
      if (!window.location.pathname.startsWith('/auth')) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;